<template>
  <p class="text-xl">
    {{ t('no-result', { keyword }) }}
  </p>
</template>

<script setup lang="ts">
  interface IProps {
    keyword: string;
  }

  withDefaults(defineProps<IProps>(), {
    keyword: '',
  });

  const { t } = useI18n({ useScope: 'local' });
</script>

<i18n lang="json">
{
  "en-int": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-jp": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-tw": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-kr": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-americas": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-asia-pacific": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "en-emea": {
    "no-result": "Your search - {keyword} - did not match any item."
  },
  "ja-jp": {
    "no-result": "検索結果 - {keyword} - 該当なし"
  },
  "zh-cn": {
    "no-result": "您的搜索 - {keyword} - 没有找到任何结果。"
  },
  "zh-tw": {
    "no-result": "您的搜尋 - {keyword} - 未找到符合結果"
  }
}
</i18n>
